import DashboardRoute from "./dashboard/Dashboard.Route";
import MasterRoute from './master/MasterRoute';
import SettingsRoute from './settings/SettingsRoute';
import UsersRoute from './users/UsersRoute';
import PremisesRoute from './premises/PremisesRoute';
import ReportRoute from "./report/ReportRoute";
import CommunicationRoute from './communication/CommunicationRoute';
import VisitorRoute from './visitor/VisitorRoute';
import HelpDeskRoute from './help_desk/HelpDeskRoute';
import NotificationsRoute from './notifications/NotificationsRoute';
import FinanceRoute from './finance/FinanceRoute';
import MaintenanceRoute from './maintenance/MaintenanceRoute';
import AmenitiesRoute from './amenities/AmenitiesRoute';
import DocumentsRoute from './documents/DocumentsRoute';

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
        ...MasterRoute(),
        ...SettingsRoute(),
        ...UsersRoute(),
        ...PremisesRoute(),
        ...ReportRoute(),
        ...CommunicationRoute(),
        ...VisitorRoute(),
        ...HelpDeskRoute(),
        ...NotificationsRoute(),
        ...FinanceRoute(),
        ...MaintenanceRoute(),
        ...AmenitiesRoute(),
        ...DocumentsRoute(),
    ]
}

export default PrivateRoute;